// Il backend serializza gli enum come stringa (JsonStringEnumConverter),
// quindi "value" deve corrispondere al nome del membro C# di StatoScadenzaMezzo.
// A differenza di StatoManutenzione non esiste "InCorso": un mezzo non ha un
// wizard di fermo, solo Pianificata/Completata/Annullata.
export const STATI_SCADENZA_MEZZO = [
    { label: "Pianificata", value: "Pianificata" },
    { label: "Completata", value: "Completata" },
    { label: "Annullata", value: "Annullata" },
];

const COLORI_STATO = {
    Pianificata: "success",
    Completata: "info",
    Annullata: "grey",
};

export function coloreStatoScadenzaMezzo(stato) {
    return COLORI_STATO[stato] || "grey";
}

export function etichettaStatoScadenzaMezzo(stato) {
    return (STATI_SCADENZA_MEZZO.find(s => s.value === stato) || {}).label || "";
}

// "Scaduta" non è un valore dell'enum, ma una condizione calcolata lato client
// a partire da stato + dataPrevista (stesso concetto usato dal backend per
// Manutenzione, qui tenuto client-side per non dipendere da campi calcolati
// aggiuntivi non garantiti dal contratto API di ScadenzaMezzo).
export function isScaduta(item) {
    if (!item || item.stato !== "Pianificata" || !item.dataPrevista) return false;
    const oggi = new Date();
    oggi.setHours(0, 0, 0, 0);
    const prevista = new Date(item.dataPrevista);
    prevista.setHours(0, 0, 0, 0);
    return prevista.getTime() < oggi.getTime();
}

export function isPrevistaOggi(item) {
    if (!item || item.stato !== "Pianificata" || !item.dataPrevista) return false;
    const oggi = new Date();
    oggi.setHours(0, 0, 0, 0);
    const prevista = new Date(item.dataPrevista);
    prevista.setHours(0, 0, 0, 0);
    return prevista.getTime() === oggi.getTime();
}

// Colore "aumentato" con la condizione di scadenza, stesso pattern usato in
// MacchinaDettaglio.vue per le manutenzioni (coloreStatoManutenzione locale).
export function coloreRiga(item) {
    if (isScaduta(item)) return "error";
    if (isPrevistaOggi(item)) return "warning";
    return coloreStatoScadenzaMezzo(item.stato);
}

export function etichettaRiga(item) {
    if (isScaduta(item)) return "Scaduta";
    if (isPrevistaOggi(item)) return "Prevista oggi";
    return etichettaStatoScadenzaMezzo(item.stato);
}
